import React, {useCallback, useEffect, useState} from 'react';
import {ScrollView, Text, View} from 'react-native';
import {useCssStyle} from '../../customHook/getCssStyle';
import HeaderWithBack from '../../components/Header/headerWithBack';
import {useNavigation} from '@react-navigation/native';
import {useDispatch, useSelector} from 'react-redux';
import {ImageComp} from '../../components/Image/Image';
import {getCleanUrl} from '../../utils/Helper';
import {getGuestItineraryList} from '../../Redux/Actions/guestItineraryAction';
import CustomPressable from '../../components/customPressable/customPressable';
import {formatLocalTime} from '../../js/utility';
import {formatDate} from '../../js/formatDate';
import CustomFlatList from '../../components/customFlatList';
import {CHEVRON_RIGHT} from '../../assets';
import {GUEST_ITINERARY_DETAILS} from '../../navigation/StackNavigator/routes';

const GuestItinerary = () => {
  const getStyles = useCssStyle();
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const {currentWidget} = useSelector(state => state.deviceConfigSlice);
  const guestItineraryList = useSelector(
    state => state.guestItinerarySlice.guestItineraryList,
  );

  const formatDateTime = dateString => {
    const date = new Date(dateString);
    // const today = props.serverTimeDate ? new Date(props.serverTimeDate.split("T")[0]) : new Date();
    const today = new Date();

    // Clear the time part for comparison
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const diffInTime = date.getTime() - today.getTime();
    const diffInDays = diffInTime / oneDayInMilliseconds;

    if (diffInDays === 0) {
      return 'Today';
    } else if (diffInDays === -1) {
      return 'Yesterday';
    } else if (diffInDays === 1) {
      return 'Tomorrow';
    } else {
      return formatDate(new Date(dateString).toISOString());
    }
  };

  const handleItemClick = item => {
    navigation.navigate(GUEST_ITINERARY_DETAILS, {item});
  };

  
  const renderList = (listItem)=>{
    const item = listItem?.item;

    const itineraries = item.itineraries;
    
    if(!item){
      return
    }
    return <View
            style={getStyles([
              'guestItineraryWidgetContainer',
              `guestItineraryWidgetContainer_${item?.id}`,
            ])}
            id={`guestItineraryWidgetContainer guestItineraryWidgetContainer_${item?.id}`}>

            {itineraries?.map((item)=><>
            <View style={getStyles(["guestItineraryWidgetItemContainer"])} id='guestItineraryWidgetItemContainer' >
                <View style={getStyles(["guestItineraryWidgetItemImageContainer"])} id='guestItineraryWidgetItemImageContainer'>
                  {<ImageComp source={getCleanUrl(item.imageUri)} style={getStyles(["guestItineraryWidgetItemImage"])} id="guestItineraryWidgetItemImage" />}
                </View>
                <View style={getStyles(["guestItineraryWidgetTitleTextContainer"])} id='guestItineraryWidgetTitleTextContainer'>
                  {item?.itineraryName && (
                    <Text
                    style={getStyles([
                      'guestItineraryWidgetTitle',
                      `guestItineraryWidgetTitle_${item?.id}`,
                    ])}
                    numberOfLines={1}
                    id={`guestItineraryWidgetTitle guestItineraryWidgetTitle_${item?.id}`}>
                      {item?.itineraryName}
                    </Text>
                  )}
                  {item?.itineraryDateTime && (
                    <Text
                      style={getStyles([
                        'guestItineraryWidgetDescription',
                        `guestItineraryWidgetDescription_${item.id}`,
                      ])}
                      id={`guestItineraryWidgetDescription guestItineraryWidgetDescription_${item.id}`}
                      numberOfLines={2}>
                      {formatLocalTime(
                        new Date(item.itineraryDateTime),
                      )}
                    </Text>
                  )}
                  {item?.itinerarySubTitle && <Text
                    style={getStyles([
                      'guestItineraryWidgetSubTitle',
                      `guestItineraryWidgetSubTitle_${item?.id}`,
                    ])}
                    numberOfLines={1}
                    id={`guestItineraryWidgetSubTitle guestItineraryWidgetSubTitle_${item?.id}`}>
                      {item?.itinerarySubTitle}
                    </Text>}

                </View>
               </View>


              <View
                style={getStyles([
                  'guestItineraryWidgetArrow_container',
                  `guestItineraryWidgetArrow_container_${item?.id}`,
                ])}
                id={`guestItineraryWidgetArrow_container guestItineraryWidgetArrow_container_${item?.id}`}>
                <ImageComp
                  source={CHEVRON_RIGHT}
                  style={getStyles([
                    'guestItineraryWidgetArrow',
                    `guestItineraryWidgetArrow_${item?.id}`,
                  ])}
                  id={`guestItineraryWidgetArrow guestItineraryWidgetArrow_${item?.id}`}
                />
              </View>
            </>)}
          </View>
  }
  return (
    <View
      id="widgetRootContainer guestitinerary_RootContainer"
      style={getStyles([
        'widgetRootContainer',
        'guestitinerary_RootContainer',
      ])}>
      <HeaderWithBack />

      <ScrollView
        showsVerticalScrollIndicator={false}
        id="widgetmainContainer guestitinerary_MainContainer"
        contentContainerStyle={getStyles([
          'widgetmainContainer',
          'guestitinerary_MainContainer',
        ])}>
        {/* Header */}
        <View
          id="widgetmainContainerHeaderContainer guestitinerary_HeaderContainer"
          style={getStyles([
            'widgetmainContainerHeaderContainer',
            'guestitinerary_HeaderContainer',
          ])}>
          {currentWidget?.widgetHeaderImageUrl && (
            <ImageComp
              source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)}
              style={getStyles([
                'widgetmainContainerHeaderImg',
                'guestitinerary_HeaderImg',
              ])}
            />
          )}
          <View
            style={getStyles([
              'widgetmainContainerHeaderTitleContainer',
              'guestitinerary_HeaderTitleContainer',
            ])}>
            <Text
              style={getStyles([
                'widgetmainContainerHeaderTitle',
                'guestitinerary_HeaderTitle',
              ])}>
              {currentWidget?.displayName}
            </Text>
          </View>
        </View>

        {/* Child Container */}
        <View
          id="widgetmainContainerChildContainer guestitinerary_MainContainerChildContainer"
          style={getStyles([
            'widgetmainContainerChildContainer',
            'guestitinerary_MainContainerChildContainer',
          ])}>


          <ScrollView
            style={getStyles([
              'widgetmainContainerChildContainer',
              'guestItineraryMainContainerChildContainer',
            ])}
            id="widgetmainContainerChildContainer guestItineraryMainContainerChildContainer"
            showsVerticalScrollIndicator={false}>
            {guestItineraryList.map((item, index) => (
              <CustomPressable
                key={index}
                onPress={() => handleItemClick(item)}
                style={getStyles([
                  'guestItineraryWidgetsWidgetContainer',
                  `guestItineraryWidgetsWidgetContainer_${item.itineraries[0].id}`,
                ])}
                id={`guestItineraryWidgetsWidgetContainer guestItineraryWidgetsWidgetContainer_${item.itineraries[0].id}`}>
                <>
                  <View
                    style={getStyles([
                      'guestItineraryWidgetHeaderTitleContainer',
                    ])}
                    id="guestItineraryWidgetHeaderTitleContainer">
                    <Text
                      style={getStyles(['guestItineraryWidgetHeaderTitle'])}
                      id="guestItineraryWidgetHeaderTitle">
                      {formatDateTime(new Date(item.itineraryDate))}
                    </Text>
                  </View>

                  {item.itineraries && (
                    <CustomFlatList
                      data={item.itineraries}
                      renderItem={renderList}
                      keyExtractor={item => item.id?.toString()}
                      showsVerticalScrollIndicator={false}
                    />
                  )}
                </>
              </CustomPressable>
            ))}
          </ScrollView>
        </View>
      </ScrollView>
    </View>
  );
};

export default GuestItinerary;
